import { Component, Inject } from '@angular/core';
import { ApiService } from '../../services';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-image-search-dialog',
  templateUrl: './image-search-dialog.component.html',
  styleUrls: ['./image-search-dialog.component.less']
})
export class ImageSearchDialogComponent {
  imageUrl: string = '';
  currentImg = '';
  currentFile: File | null = null;
  imgURL = '';
  status: { type: string; message: string; };
  text = 'Drag an image here or click to upload';
  constructor(private api: ApiService, private dialog: MatDialog, private router: Router, 
            private dialogRef: MatDialogRef<ImageSearchDialogComponent>,
    
         @Inject(MAT_DIALOG_DATA) public data,
  ) {
    if (window.innerWidth < 900) {
      this.text = 'Upload Image';
    }

  }
  handleFileSelect(event: any): void {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.currentImg = e.target.result;
        this.currentFile = file;
        const imgData = {
          image_url: this.imgURL,
          image_upload: this.currentFile,
          img_preview: this.currentImg
        }
        this.api.imgSearchData = imgData;
        console.log(this.api.imgSearchData);
        // sessionStorage.setItem('imgSearchData', JSON.stringify(imgData));
        // this.api.setImgSearchData(imgData);
        if(this.data && this.data.page=='catalog'){
          this.dialogRef.close(imgData)
        }else{
          this.router.navigate(['/search']).then(() => {
          this.dialog.closeAll();
        });
      }

      };
      reader.readAsDataURL(file);
    }
  }


  isDragOver = false;

  onDragOver(event: DragEvent) {
    event.preventDefault(); // Prevent default behavior (opening file)
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    this.isDragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;

    if (event.dataTransfer?.files.length) {
      const files = event.dataTransfer.files;
      this.handleFileSelect({ target: { files } }); // Simulate file input event
    }
  }
  searchImage(): void {
    const invalid = this.imgURL.trim().startsWith('http');

    if (!invalid) {
      this.status = { type: 'error', message: `Invalid URL found.` };

    } else {
      const imgData = {
        image_url: this.imgURL,
        image_upload: this.currentFile
      }
      this.api.imgSearchData = imgData;
      this.router.navigate(['/search'])
      this.dialog.closeAll();
      // this.api.searchProducts('', 1, imgData).subscribe(res => {

      // })
    }
  }
}
